import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from 'src/store';
import { progressSelectorFactory } from 'src/common/store/selectors';
import { selectAfslId, selectAssetClassOrderItems, selectAssetClassOverrideItems } from './store/selectors';
import { ReportSettings } from './components/ReportSettings';
import { reportSettingsSlice } from './store/slice';
import {
  selectAfsls,
  fetchAfsls,
  fetchAssetClassOrder,
  upsertAssetClassOrder,
  fetchAssetClassOverride,
  upsertAssetClassOverride,
  AssetClassOrderTypes,
} from './store';

const mapStateToProps = (state: RootState) => ({
  afsls: selectAfsls(state),
  afslId: selectAfslId(state),
  assetClassOrderItems: selectAssetClassOrderItems(state),
  assetClassOverrideItems: selectAssetClassOverrideItems(state),
  reportSettingsLoadingProgress: progressSelectorFactory([AssetClassOrderTypes.FetchAssetClassOrder])(state),
});

interface MatchParams {
  afslId: string;
}

const mapDispatchToProps = {
  ...reportSettingsSlice.actions,

  fetchAssetClassOrder,
  fetchAssetClassOverride,
  upsertAssetClassOrder,
  upsertAssetClassOverride,
  fetchAfsls,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector> & RouteComponentProps<MatchParams>;
export const ReportSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(ReportSettings);
